<script setup>
import {Head} from '@inertiajs/vue3';
import StoreLayout from '@/Layouts/StoreLayout.vue';
import Collection from "@/Pages/Collection/Partials/Collection.vue";
import Highlight from "@/Pages/Collection/Partials/Highlight.vue";
import Container from "@/Components/Container.vue";
import PageTitle from "@/Components/PageTitle.vue";

defineProps({
    title: String,
    collection: Object,
    items: Object,
});
</script>

<template>
    <Head :title="collection.name"/>

    <StoreLayout>
        <Container>
            <Highlight :prefix="title" :collection="collection" :link="true"/>
            <Collection :grid-size="0" :items="items" :hide-labels="[collection.name]" :hide-subtitle="collection.name"/>
        </Container>
    </StoreLayout>
</template>
